export default {
  'funnel:cart-box:questions': 'Got questions about your order?',
  'funnel:cart-box:call': 'Just give us a call!',
  'funnel:cart-box:phone-number': '+49 30-22 05 6 44 05',
  'funnel:cart-box:opening-hours': 'Mon-Fri 9am-6pm',
  'funnel:configurator:modal-title':
    'Configure the product just the way it suits you best',
  'funnel:configurator:most-popular': 'Most popular',
  'funnel:configurator:add-to-cart': 'Add to cart',

  'funnel:configurator:confirm-selection': 'Confirm selection',
  'funnel:configurator:one-off-price': 'Price for one-time delivery',
  'funnel:configurator:subscription-price': 'Price for regular delivery',
};
